import * as Reducers from './duplicate-session-detector.reducers';
import * as MetaReducers from './duplicate-session-detector.metareducers';

export const DuplicateSessionDetectorReducers = {
  Reducers,
  MetaReducers
};
